/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subtitle_Export_Profile_LabelInputs */



/**
* | output |
* | --- |
* | "Profile" |
*
* @param {Subtitle_Export_Profile_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_export_profile_label = /** @type {((inputs?: Subtitle_Export_Profile_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Export_Profile_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Profil")
	if (locale === "de") return /** @type {LocalizedString} */ ("Profil")
	if (locale === "it") return /** @type {LocalizedString} */ ("Profilo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Профиль")
	if (locale === "es") return /** @type {LocalizedString} */ ("Perfil")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("轮廓")
	if (locale === "ja") return /** @type {LocalizedString} */ ("プロフィール")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्रोफ़ाइल")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Perfil")
	return /** @type {LocalizedString} */ ("Profile")
});